import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types'
import { VIEW_MODES } from '_hooks/useViewMode'
import './style.scss'

const SORT_OPTIONS = [
  { key: 'newest', label: 'Newest Event' },
  { key: 'closing', label: 'Closing Soon' },
  { key: 'collection', label: 'Collection Date' },
  { key: 'active', label: 'Most Active' },
];

export default function SwitchViewEvent({
  view = VIEW_MODES.LIST,
  onChange,
  totalEvents = 0,
  currentSort,
  onSelectSort
}) {
  const currentView = view || VIEW_MODES.LIST

  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

  const toggleSortMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelectSort = (sortKey) => {
    setIsOpen(false);
    if (onSelectSort) {
      onSelectSort(sortKey);
    }
  };

  const handleToggle = (mode) => {
    if (typeof onChange === 'function') {
      onChange(mode)
    }
  }

  const currentSortLabel = SORT_OPTIONS.find((item) => item.key === currentSort)?.label || 'Sort';

  return (
    <div className='feed-header'>
      <span className='feed-header-count'>{`${totalEvents} EVENTS`}</span>
      <div className='action-bar-container'>
        <div className="mef-sort-bar">
          <div className="mef-sort-wrap" ref={menuRef}>
            <button className="mef-sort-btn" id="mef-sort-btn" onClick={toggleSortMenu}>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="4" y1="6" x2="20" y2="6"></line>
                <line x1="8" y1="12" x2="16" y2="12"></line>
                <line x1="11" y1="18" x2="13" y2="18"></line>
              </svg>
              <span id="mef-sort-label">{currentSortLabel}</span>
            </button>

            {isOpen && (
              <div className="mef-sort-menu open" id="mef-sort-menu">
                {SORT_OPTIONS.map((item) => (
                  <div
                    key={item.key}
                    className={`mef-sort-item ${currentSort === item.key ? 'active' : ''}`}
                    data-sort={item.key}
                    onClick={() => handleSelectSort(item.key)}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className='mef-view-toggle'>
          <button
            type='button'
            className={currentView === VIEW_MODES.LIST ? 'active' : ''}
            id='mef-btn-list'
            onClick={() => handleToggle(VIEW_MODES.LIST)}
            title='List view'
            aria-label='List view'
          >
            <svg width='12' height='12' viewBox='0 0 14 14' fill='currentColor'>
              <rect y='1' width='14' height='2' rx='1' />
              <rect y='6' width='14' height='2' rx='1' />
              <rect y='11' width='14' height='2' rx='1' />
            </svg>
          </button>
          <button
            type='button'
            className={currentView === VIEW_MODES.TILE ? 'active' : ''}
            id='mef-btn-tile'
            onClick={() => handleToggle(VIEW_MODES.TILE)}
            title='Tile view'
            aria-label='Tile view'
          >
            <svg width='12' height='12' viewBox='0 0 14 14' fill='currentColor'>
              <rect x='0' y='0' width='6' height='6' rx='1' />
              <rect x='8' y='0' width='6' height='6' rx='1' />
              <rect x='0' y='8' width='6' height='6' rx='1' />
              <rect x='8' y='8' width='6' height='6' rx='1' />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}

SwitchViewEvent.propTypes = {
  view: PropTypes.string,
  onChange: PropTypes.func,
  totalEvents: PropTypes.number,
}
